import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useAuth } from '../auth/AuthContext';
import { CustomersPage } from './customers';

/**
 * Root route. Practitioners with an active session see the accounts
 * dashboard inline (no extra hop); everyone else gets bounced to
 * `/sign-in`. The dispatch decision is made on the post-sign-in
 * route (`/sign-in/done`), so customers landing here mid-session
 * still get routed to `/portal` from there.
 */
export function IndexPage() {
  const { isSignedIn, isAuthReady } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Gate on `isAuthReady` so a still-hydrating Clerk session isn't
    // briefly treated as signed-out and bounced to /sign-in.
    if (isAuthReady && !isSignedIn) {
      void navigate({ to: '/sign-in', replace: true });
    }
  }, [isAuthReady, isSignedIn, navigate]);

  if (isSignedIn) {
    return <CustomersPage />;
  }

  // Render nothing while we either wait for auth to hydrate (isAuthReady
  // false) or while the redirect effect runs.
  return null;
}
